import type { LocalizedDict } from '../index'

// Settings → Tags, real-engine read-only view (RealTagManagement.tsx). The
// rest of its text comes from the shared tag-management dictionary.
export type RealTagManagementStrings = {
  readOnlyNote: string
}

export const realTagManagementI18n: LocalizedDict<RealTagManagementStrings> = {
  en: {
    readOnlyNote: 'Read-only tag vocabulary. Tag authoring is not yet backed by the platform.',
  },
  tr: {
    readOnlyNote: 'Etiket listesi salt okunur. Etiket ekleme ve düzenleme henüz platformda desteklenmiyor.',
  },
}
